export default __webpack_public_path__ + "static/media/Showcase_Empty.75d15c99.png";